import textGuard from "et3-text-guard";
import { alarmingEmojis } from "./alarming-emojis";
export const et3CheckText = (text: string) => {
  let descriptionClean = text.replace(/(?=\s)[^\r\n\t]/g, " ");
  descriptionClean.trim();
  descriptionClean.replace(/\s+/g, " ");
  // In order to catch the bad words
  const descriptionText = descriptionClean.trim();
  const isEmailExist = textGuard.checkHasEmailExists(descriptionText);
  const isSocialMediaExits = textGuard.checkHasSocialMedia({
    text: descriptionText,
    socialMedia: [],
    useAdditionalDefault: true,
    exactAppearance: true
  });
  const isBadWordsExists = textGuard.checkHasBadWords({
    text: descriptionText,
    badWords: [...alarmingEmojis],
    useAdditionalDefault: true,
    exactAppearance: true
  });
  const isPhoneNumberExists = textGuard.checkHasPhoneNumber(descriptionText);

  const isRestrictedPhrasesExists = textGuard.checkHasRestrictedPhrases({
    text: descriptionClean,
    restrictedPhrases: [],
    useAdditionalDefault: true
  });

  console.warn("isRestrictedPhrasesExists", isRestrictedPhrasesExists);

  return {
    isEmailExist,
    isSocialMediaExits,
    isBadWordsExists,
    isPhoneNumberExists,
    isRestrictedPhrasesExists
  };
};
